import client from './client'

export default class RadioAccessService {
  list (params) {
    return client.get('api/radio-access', params)
  }
}
